import {IAbstractModule, IModuleType} from "@/model/Locker/IModule";

export const ModuleMixAlt: IAbstractModule = {
  type: IModuleType.mix,
  name: 'Mix 12 alt',
  hasScreen: false,
  columns: [
    [
      {
        name: "5",
        connector: "5",
        cell_size_id: 1,
        accessible: false,
      },
      {
        name: "6",
        connector: "6",
        cell_size_id: 3,
        accessible: true,
      },
      {
        name: "7",
        connector: "7",
        cell_size_id: 3,
        accessible: true,
      },
      {
        name: "8",
        connector: "8",
        cell_size_id: 3,
        accessible: true,
      },
      {
        name: "13",
        connector: "13",
        cell_size_id: 3,
        accessible: true,
      },
      {
        name: "14",
        connector: "14",
        cell_size_id: 4,
        accessible: false,
      },
    ],
    [
      {
        name: "1",
        connector: "1",
        cell_size_id: 1,
        accessible: false,
      },
      {
        name: "2",
        connector: "2",
        cell_size_id: 3,
        accessible: true,
      },
      {
        name: "3",
        connector: "3",
        cell_size_id: 3,
        accessible: true,
      },
      {
        name: "4",
        connector: "4",
        cell_size_id: 3,
        accessible: true,
      },
      {
        name: "9",
        connector: "9",
        cell_size_id: 3,
        accessible: true,
      },
      {
        name: "10",
        connector: "10",
        cell_size_id: 4,
        accessible: false,
      },
    ]
  ]
};
